import Image from 'next/image';
import React, { useState } from 'react';
import YetAnotherReactLightbox, {
  type SlideImage,
} from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';

import leftButtonImage from '@/ui/resources/svg/button-carousel-left.svg';
import rightButtonImage from '@/ui/resources/svg/button-carousel-right.svg';
import { useTheme } from '@/ui/theme';

import { CloseButton } from '../CloseButton.component';
import { NextJsImage } from './NextJsImage';

interface LightboxProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  index: number;
  children: SlideImage[];
}

export const Lightbox = ({
  isOpen,
  setIsOpen,
  index,
  children,
}: LightboxProps) => {
  const { componentProperties } = useTheme();
  const [currentIndex, setCurrentIndex] = useState(index);

  return (
    <YetAnotherReactLightbox
      open={isOpen}
      close={() => setIsOpen(false)}
      slides={children}
      controller={{
        closeOnBackdropClick: true,
      }}
      on={{
        view: ({ index }) => {
          setCurrentIndex(index);
        },
      }}
      render={{
        slide: NextJsImage,
        buttonClose: () => (
          <CloseButton
            css={{
              backgroundColor: 'white',
              padding: '12.5px',
              borderRadius: '100%',
              border: `1px solid grey`,
              img: {
                width: '15px',
                height: '15px',
              },
              transition: 'opacity 0.3s ease, box-shadow 0.3s ease',
              opacity: 0.5,
              '&:hover': {
                opacity: 1,
                boxShadow: '1px 1px 2px 0 rgba(0, 0, 0, 0.3)',
              },
            }}
            onClick={() => setIsOpen(false)}
          />
        ),
        iconNext: () => (
          <Image
            css={{
              opacity: currentIndex === children.length - 1 ? 0.5 : 0.75,
              position: 'relative',
              borderRadius: '100%',
              ':focus, :hover': {
                opacity: currentIndex === children.length - 1 ? 0.5 : 1,
                boxShadow:
                  currentIndex !== children.length - 1
                    ? '1px 1px 2px 0 rgba(0, 0, 0, 0.3)'
                    : 'none',
              },
            }}
            width={40}
            height={40}
            src={rightButtonImage.src}
            alt=""
          />
        ),
        iconPrev: () => (
          <Image
            css={{
              opacity: currentIndex === 0 ? 0.5 : 0.75,
              position: 'relative',
              borderRadius: '100%',
              ':focus, :hover': {
                opacity: currentIndex === 0 ? 0.5 : 1,
                boxShadow:
                  currentIndex !== 0
                    ? '1px 1px 2px 0 rgba(0, 0, 0, 0.3)'
                    : 'none',
              },
            }}
            width={40}
            height={40}
            src={leftButtonImage.src}
            alt=""
          />
        ),
      }}
      index={index}
      carousel={{
        finite: true,
      }}
      styles={{
        container: {
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          ...componentProperties.modals?.overlay,
        },
      }}
    />
  );
};
